import { z } from "zod";

import { RENTAL_DEAL_LIST_SORT_FIELDS } from "../../entities/rental-deal/constants";
import { zodEnum } from "../../shared/lib/zod-enum";
import { SORT_DIRECTIONS } from "../../shared/types/sort";

export const dealsSearchParamsSchema = z.object({
  sorting: z
    .enum(zodEnum(Object.values(RENTAL_DEAL_LIST_SORT_FIELDS)))
    .optional()
    .catch(undefined),
  sortingDir: z
    .enum(zodEnum(Object.values(SORT_DIRECTIONS)))
    .optional()
    .catch(undefined),
});

export type DealsSearch = z.infer<typeof dealsSearchParamsSchema>;
